import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { User } from '@app/shared/interfaces';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { IntercomService } from '@app/shared/services/intercom.service';
import { SettingsService } from '@app/shared/services/settings/settings.service';

declare let window: Window;

@Component({
  standalone: false,
  selector: 'sbnb-connect-shared-twofa',
  templateUrl: './connect-shared-twofa.component.html',
  styleUrls: ['./connect-shared-twofa.component.scss'],
})
export class ConnectSharedTwofaComponent implements OnInit {
  @Input() verificationData: any;
  @Input() platform: 'airbnb' | 'homeaway' | 'booking';
  @Input() loading: boolean;
  @Output() phaseComplete: EventEmitter<any> = new EventEmitter();

  iosApp: boolean;

  window = window;

  user: User;

  selected2FaType: string;
  selected2FaId: number;

  completionUrl: string;
  verificationCode: string;

  captchaClicked: boolean; // Whether the captcha link has been opened by the user

  constructor(
    private readonly settingsService: SettingsService,
    private readonly authService: AuthenticationService,
    private readonly deviceDetectionService: DeviceDetectionService,
    private readonly intercomService: IntercomService
  ) { }

  ngOnInit(): void {
    this.user = this.authService.getUserDetails();
    this.iosApp = this.deviceDetectionService.isIosApp();
  }

  openAirbnbCaptcha() {
    this.popup(this.verificationData.external_url, 600, 300);

    setTimeout(() => {
      this.captchaClicked = true;
    }, 1000);
  }

  openIntercom() {
    this.intercomService.showNewMessage('I need some help with solving an Airbnb captcha');
  }

  private popup(url, width, height) {
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    const opener = window.open(
      url,
      '',
      `menubar=no, toolbar=no, status=no, resizable=yes, scrollbars=yes, width=${width},height=${height},top=${top},left=${left}`
    );

    window.setTimeout(() => {
      if (!opener || opener.closed || typeof opener.closed === 'undefined') {
        // Blocked, open in a new tab as a fallback
        window.open(url, '_blank');
      }
    }, 1000);
  }

  selectedOptionChangeRadio(event: MatRadioChange, group: any) {
    this.selected2FaType = group.value;
    this.selected2FaId = event.value.value;
  }

  request2FaCode() {
    this.loading = true;

    this.settingsService
      .start2faWithOptions(this.verificationData.url, this.selected2FaType, this.selected2FaId)
      .subscribe((res) => {
        this.loading = false;
        this.completionUrl = res.url;
      });
  }

  submit2FaCode() {
    this.loading = true;

    this.settingsService
      .validate2faCode(this.completionUrl, this.selected2FaType, this.selected2FaId, this.verificationCode)
      .subscribe((res) => {
        this.loading = false;

        if (res.error) {
          return;
        }

        this.phaseComplete.emit(res);
      });
  }
}
